<template>
  <div
    class="mb-0 flex cursor-pointer items-center justify-center gap-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-50"
    :class="{ 'bg-gray-100': is_active }"
    data-test="project-navbar-item"
    @click="handleClick"
  >
    <img
      class="shrink-0 rounded-full"
      :src="project.attributes.picture_login_url_m"
      :class="is_navbar_expanded ? 'size-6' : 'size-8'"
      @click="togglePopover"
    />

    <div
      v-if="is_navbar_expanded"
      class="flex w-full items-center justify-between"
    >
      <div
        class="min-w-0 flex-1 truncate text-sm"
        :class="{ 'font-bold text-gray-500': is_active }"
      >
        {{ project.attributes.name }}
      </div>
      <FontAwesomeIcon
        v-if="!is_active"
        class="shrink-0 text-xs text-gray-400"
        :icon="['fa', 'chevron-down']"
        style="margin-bottom: 1px"
      />
      <FontAwesomeIcon
        v-else
        class="shrink-0 text-xs text-gray-400"
        :icon="['fa', 'chevron-up']"
      />
    </div>
  </div>
  <div v-if="!is_navbar_expanded">
    <Popover ref="popover">
      <DropdownOption
        v-for="item in routes_active"
        class="py-2"
      >
        <AppLink
          :key="item.name"
          :class="{
            'has-background-primary-light shadow-sm':
              route.name.startsWith(item.prefix) && project.id === route.params.project_id,
          }"
          :data-test="item.data_test"
          :title="!mq.isMobile ? $t(item.title) : ''"
          :to="{ name: item.name, params: { project_id: project.id } }"
          @click="handleClickRoute"
        >
          <div>
            <div
              :class="[
                route.name.startsWith(item.prefix) && project.id === route.params.project_id
                  ? 'has-text-primary text-sm font-bold'
                  : 'text-sm font-medium text-gray-500',
              ]"
            >
              {{ $t(item.title) }}
            </div>
          </div>
        </AppLink>
      </DropdownOption>
    </Popover>
  </div>
  <div v-else>
    <div
      v-if="is_active"
      class="mx-3 my-1 flex flex-col gap-1"
    >
      <AppLink
        v-for="item in routes_active"
        :key="item.name"
        class="rounded-md px-3 py-1 hover:bg-gray-50"
        :class="{
          'has-background-primary-light shadow-sm':
            route.name.startsWith(item.prefix) && project.id === route.params.project_id,
        }"
        :data-test="item.data_test"
        :title="!mq.isMobile ? $t(item.title) : ''"
        :to="{ name: item.name, params: { project_id: project.id } }"
        @click="mq.isMobile && emit('close')"
      >
        <div>
          <div
            :class="[
              route.name.startsWith(item.prefix) && project.id === route.params.project_id
                ? 'has-text-primary text-sm font-bold'
                : 'text-sm font-medium text-gray-500',
            ]"
          >
            {{ $t(item.title) }}
          </div>
        </div>
      </AppLink>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import { useRoute } from 'vue-router';
import {
  NAVBAR_ITEMS_PARTNERS_PROJECT,
  NAVBAR_ITEMS_PARTNERS_PROJECT_ACTIVE_ROLE_NEEDED,
} from '@/app/data/navbar_constants';
import { useStore } from 'vuex';
import DropdownOption from '@/app/shared_components/buttons/DropdownOption.vue';

const store = useStore();

const { proxy: app } = getCurrentInstance();

const route = useRoute();

const current_profile = computed(() => store.getters.current_profile);
const popover = ref(null);

const props = defineProps({
  project: { type: Object, required: true },
  is_active: { type: Boolean, default: false },
  is_navbar_expanded: { type: Boolean, default: true },
});

const emit = defineEmits(['toggle']);

const handleClick = () => {
  emit('toggle', props.project.id);
};

const is_route_active = (r) => {
  if (r.flipper && !app.$flipper.enabled(r.flipper)) return false;
  if (!props.project) return false;
  if (NAVBAR_ITEMS_PARTNERS_PROJECT_ACTIVE_ROLE_NEEDED.includes(r.name)) {
    return current_profile.value.attributes.active_role_project_ids.includes(parseInt(props.project.id, 10));
  }
  return true;
};

const routes_active = computed(() => NAVBAR_ITEMS_PARTNERS_PROJECT.filter(is_route_active));

const handleClickRoute = () => {
  hidePoppover();
  emit('close');
};

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const hidePoppover = (e) => {
  popover.value.hide(e);
};
</script>
